module.exports = __webpack_public_path__ + "static/media/undraw_files_6b3d.58bd3d2f.svg";